import { Controller } from "react-hook-form";

const RadioButton = ({
  className,
  type,
  label,
  control,
  rules,
  name,
  onChangeFn,
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <>
          <label className={" cursor-pointer " + className}>
            <input
              type="radio"
              checked={value === props.value}
              onChange={(e) => {
                onChange(e);
                onChangeFn?.(e);
              }}
              name={name}
              className="mr-2"
              {...props}
            />
            {label}
          </label>
          {error && (
            <small className="text-red-600 font-medium text-sm">
              {error.message}
            </small>
          )}
        </>
      )}
    />
  );
};

export default RadioButton;
